<template>
  <div>
    <horizontal-navbar></horizontal-navbar>
    <breadcrumb-slot :items="items" :modal="false"></breadcrumb-slot>

    <div class="p-1 d-flex justify-content-between">
      <h2 class="text-dark">ცვლადები</h2>
    </div>

    <table-basic v-if="default_symptoms.length > 0" @save="saveSymptom"
                 @delete="deleteSymptom" @add="addModal({item: 'symptom', title: 'სიმპტომი'})"
                 :draggable="false" :title="{georgian: 'მიმდინარე სიმპტომები', english: 'symptoms'}" :type="'multiple'"
                 :rows="symptoms" :defaultRows="default_symptoms" :columns="columns"></table-basic>

    <table-basic v-if="default_risk_factors.length > 0 || risk_factors.length > 0"
                 :title="{georgian: 'რისკ-ჯგუფები', english: 'risk_factors'}" :type="'multiple'" :columns="columns"
                 :rows="risk_factors" :defaultRows="default_risk_factors" :draggable="true"
                 @update="updateRiskFactorRows" @add="addModal({item: 'risk_factor', title: 'რისკ ფაქტორი'})"
                 @save="saveRiskFactor" @delete="deleteRiskFactor"></table-basic>

    <table-basic
                 :title="{georgian: 'არასასურველი მოვლენა', english: 'side_effects'}" :type="'multiple'"
                 :columns="columns"
                 :rows="side_effects" :defaultRows="default_side_effects" :draggable="false"
                 @add="addModal({item: 'side_effects', title: 'არასასურველი მოვლენა'})"
                 @save="saveSideEffect" @delete="deleteSideEffect"></table-basic>

    <table-basic v-if="default_laboratory_monitoring.length > 0 || laboratory_monitoring.length > 0"
                 :title="{georgian: 'ლაბორატორიული კვლევა', english: 'laboratory_monitoring'}" :type="'multiple'"
                 :columns="columns"
                 :rows="laboratory_monitoring" :defaultRows="default_laboratory_monitoring" :draggable="false"
                 @add="addModal({item: 'laboratory_monitoring', title: 'ლაბორატორიული კვლევა'})"
                 @save="saveLaboratoryMonitoring" @delete="deleteLaboratoryMonitoring"></table-basic>

    <table-basic v-if="false" :title="{georgian:'ტუბერკულოზის ლოკალიზაცია', english: 'localization'}" :type="'single'"
                 :rows="tbi_localization"
                 :defaultRows="default_tbi_localization"
                 @add="addModal({item: 'tbi_localization', title: 'ტუბერკულოზის ლოკალიზაციი'})"
                 @save="saveTbiLocalizations" :draggable="false"
                 @delete="deleteTbiLocalization" :columns="columns"></table-basic>

    <b-modal id="modal-add-variable"
             ref="variable-modal"
             size="lg"
             class="p-3"
             hide-header
             hide-footer
             centered>

      <div class="modal-custom-header d-flex align-items-center justify-content-between">
        <h4>{{ modal_item.title }}ს დამატება</h4>

        <b-button variant="flat-secondary" class="btn-icon mr-1" size="lg" @click="hideModal">
          <feather-icon icon="XIcon"/>
        </b-button>
      </div>

      <b-form class="d-flex justify-content-between">
        <b-form-group label="ქართულად *"
                      label-for="nameGe">
          <b-form-input id="nameGe" v-model="georgianVariable"
                        placeholder=""/>
        </b-form-group>
        <b-form-group label="ინგლისურად *"
                      label-for="nameEng">
          <b-form-input id="nameEng" v-model="englishVariable"
                        placeholder=""/>
        </b-form-group>
      </b-form>

      <div class="mt-3 d-flex justify-content-between align-items-center">

        <b-button variant="primary" class="save-changes mb-3" @click="addVariable">
          <feather-icon icon="SaveIcon"
                        class="mr-50"/>
          <span class="align-middle">დაამატე</span>
        </b-button>

      </div>
    </b-modal>
  </div>
</template>

<script>
import BreadcrumbSlot from "../components/breadcrumb/BreadcrumbSlot";
import TableBasic from "../table/bs-table/TableBasic";
import moduleVariables from "../../store/variables/moduleVariables";
import {
  BButton,
  BModal,
  BForm,
  BFormGroup,
  BFormInput,
} from "bootstrap-vue";
import HorizontalNavbar from "../navbar/HorizontalNavbar";


export default {
  name: "Variables",
  components: {
    HorizontalNavbar,
    TableBasic,
    BreadcrumbSlot,
    BButton,
    BModal,
    BForm,
    BFormGroup,
    BFormInput,
  },
  data() {
    return {
      items: [
        {
          text: "ცვლადები",
          active: true
        }
      ],
      columns: [
        {
          key: "georgian",
          label: "ქართული",
          sortable: true
        },
        {
          key: "english",
          label: "ინგლისური",
          sortable: true
        },
        {
          key: "actions",
          label: "",
        },
      ],
      englishVariable: "",
      georgianVariable: "",
      title: "",
      modal_item: {},
      risk_factors_v: [],
    }
  },

  created() {
    if (!moduleVariables.isRegistered) {
      this.$store.registerModule("variables", moduleVariables);
      moduleVariables.isRegistered = true
    }
    this.getSymptoms();
    this.getRiskFactors();
    // this.getTbiLocalizations();
    this.getSideEffects();
    this.getLaboratoryMonitoring();
  },

  computed: {
    symptoms() {
      return this.$store.state.variables.symptoms
    },
    default_symptoms() {
      return this.$store.state.variables.default_symptoms
    },
    risk_factors() {
      return this.$store.state.variables.risk_factors
    },
    default_risk_factors() {
      return this.$store.state.variables.default_risk_factors
    },
    tbi_localization() {
      return this.$store.state.variables.tbi_localization
    },
    default_tbi_localization() {
      return this.$store.state.variables.default_tbi_localization
    },
    side_effects() {
      return this.$store.state.variables.side_effects
    },
    default_side_effects() {
      return this.$store.state.variables.default_side_effects
    },
    laboratory_monitoring() {
      return this.$store.state.variables.laboratory_monitoring
    },
    default_laboratory_monitoring() {
      return this.$store.state.variables.default_laboratory_monitoring
    },
  },

  methods: {

    addModal(item) {
      this.modal_item = item;
      console.log("this.modal_item", this.modal_item)
      this.showModal();
    },

    addVariable() {
      if (this.modal_item.item === "symptom") {this.addSymptom();}
      if (this.modal_item.item === "risk_factor") {this.addRiskFactor();}
      if (this.modal_item.item === "tbi_localization") {this.addTbiLocalizations();}
      if (this.modal_item.item === "side_effects") {this.addSideEffect();}
      if (this.modal_item.item === "laboratory_monitoring") {this.addLaboratoryMonitoring();}
    },

    getSymptoms(payload = {}) {
      // this.tableVisible = false;
      this.$store.dispatch("variables/getSymptoms", payload).then(() => {
        // this.tableVisible = true;
      }).catch((err) => {
      });
    },

    addSymptom() {
      let payload = {
        "default": false,
        "isSingular": true,
        "translations": [
          {
            "languageCode": "ka",
            "title": this.georgianVariable
          },
          {
            "languageCode": "en",
            "title": this.englishVariable
          }
        ]
      };

      this.$store.dispatch("variables/addSymptom", payload).then(() => {
        this.getSymptoms();
        this.hideModal();
      }).catch((err) => {
      });
    },

    saveSymptom(item) {
      this.$store.dispatch("variables/saveSymptom", item).then(() => {
        this.getSymptoms();
        this.hideModal();
      }).catch((err) => {
      });
    },

    deleteSymptom(item = {}) {
      // this.tableVisible = false;
      this.warning().then((value) => {
        if (value.isConfirmed) {
          this.$store.dispatch("variables/deleteSymptom", {id: item.id}).then(() => {
            // this.tableVisible = true;
            this.getSymptoms();
          }).catch((err) => {
          });
        }
      });
    },

    getRiskFactors(payload = {}) {
      // this.tableVisible = false;
      this.$store.dispatch("variables/getRiskFactors", payload).then(() => {
        // this.tableVisible = true
        this.risk_factors_v = this.$store.state.variables.risk_factors;
      }).catch((err) => {
      });
    },

    updateRiskFactorRows(payload) {
      // this.tableVisible = false;
      this.$store.dispatch("variables/updateRiskFactorRows", payload).then(() => {
        this.getRiskFactors();
        // this.tableVisible = true
      }).catch((err) => {
      });
    },

    addRiskFactor() {
      let payload = {
        "translations": [
          {
            "languageCode": "ka",
            "title": this.georgianVariable
          },
          {
            "languageCode": "en",
            "title": this.englishVariable
          }
        ]
      };

      this.$store.dispatch("variables/addRiskFactor", payload).then(() => {
        this.getRiskFactors();
        this.hideModal();
      }).catch((err) => {
      });
    },

    addLaboratoryMonitoring() {
      let payload = {
        "translations": [
          {
            "languageCode": "ka",
            "title": this.georgianVariable
          },
          {
            "languageCode": "en",
            "title": this.englishVariable
          }
        ]
      };

      this.$store.dispatch("variables/addLaboratoryMonitoring", payload).then(() => {
        this.getLaboratoryMonitoring();
        this.hideModal();
      }).catch((err) => {
      });
    },

    saveRiskFactor(item) {
      this.$store.dispatch("variables/saveRiskFactor", item).then(() => {
        this.getRiskFactors();
        this.hideModal();
      }).catch((err) => {
      });
    },

    saveSideEffect(item) {
      this.$store.dispatch("variables/saveSideEffect", item).then(() => {
        this.getSideEffects();
        this.hideModal();
      }).catch((err) => {
      });
    },

    saveLaboratoryMonitoring(item) {
      this.$store.dispatch("variables/saveLaboratoryMonitoring", item).then(() => {
        this.getLaboratoryMonitoring();
        this.hideModal();
      }).catch((err) => {
      });
    },

    deleteRiskFactor(item) {
      // this.tableVisible = false;
      this.warning().then((value) => {
        if (value.isConfirmed) {
          this.$store.dispatch("variables/deleteRiskFactor", {id: item.id}).then(() => {
            // this.tableVisible = true;
            this.getRiskFactors();
          }).catch((err) => {
          });
        }
      });
    },

    deleteSideEffect(item) {
      // this.tableVisible = false;
      this.warning().then((value) => {
        if (value.isConfirmed) {
          this.$store.dispatch("variables/deleteSideEffect", {id: item.id}).then(() => {
            // this.tableVisible = true;
            this.getSideEffects();
          }).catch((err) => {
          });
        }
      });
    },

    deleteLaboratoryMonitoring(item) {
      // this.tableVisible = false;
      this.warning().then((value) => {
        if (value.isConfirmed) {
          this.$store.dispatch("variables/deleteLaboratoryMonitoring", {id: item.id}).then(() => {
            // this.tableVisible = true;
            this.getLaboratoryMonitoring();
          }).catch((err) => {
          });
        }
      });
    },

    getTbiLocalizations(payload = {}) {
      // this.tableVisible = false;
      this.$store.dispatch("variables/getTbiLocalizations", payload).then(() => {
        // this.tableVisible = true;
      }).catch((err) => {
      });
    },

    addTbiLocalizations() {
      let payload = {
        "translations": [
          {
            "languageCode": "ka",
            "title": this.georgianVariable
          },
          {
            "languageCode": "en",
            "title": this.englishVariable
          }
        ]
      };

      this.$store.dispatch("variables/addTbiLocalizations", payload).then(() => {
        this.getTbiLocalizations();
        this.hideModal();
      }).catch((err) => {
      });
    },

    addSideEffect() {
      let payload = {
        "translations": [
          {
            "languageCode": "ka",
            "title": this.georgianVariable
          },
          {
            "languageCode": "en",
            "title": this.englishVariable
          }
        ]
      };

      this.$store.dispatch("variables/addSideEffect", payload).then(() => {
        this.getSideEffects();
        this.hideModal();
      }).catch((err) => {
      });
    },

    saveTbiLocalizations(item) {
      this.$store.dispatch("variables/saveTbiLocalizations", item).then(() => {
        this.getTbiLocalizations();
        this.hideModal();
      }).catch((err) => {
      });
    },

    deleteTbiLocalization(item) {
      // this.tableVisible = false;
      this.warning().then((value) => {
        if (value.isConfirmed) {
          this.$store.dispatch("variables/deleteTbiLocalization", {id: item.id}).then(() => {
            // this.tableVisible = true;
            this.getTbiLocalizations();
          }).catch((err) => {
          });
        }
      });
    },

    getSideEffects(payload = {}) {
      // this.tableVisible = false;
      this.$store.dispatch("variables/getSideEffects", payload).then(() => {
        // this.tableVisible = true;
      }).catch((err) => {
      });
    },

    getLaboratoryMonitoring(payload = {}) {
      // this.tableVisible = false;
      this.$store.dispatch("variables/getLaboratoryMonitoring", payload).then(() => {
        // this.tableVisible = true;
      }).catch((err) => {
      });
    },

    warning() {
      return this.$swal({
        title: "<span class=\"font-medium-1\">დარწმუნებული ხარ რომ გსურს წაშლა?</span>",
        icon: "warning",
        html:
            "<span class=\"font-small-3\">წაშლის შემდეგ ინფორმაციის აღდგენა შეუძლებელია</span>",
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonText: "დიახ წაშალე",
        cancelButtonText: "გაუქმება",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      })
    },

    hideModal() {
      this.englishVariable = "";
      this.georgianVariable = "";
      this.$refs["variable-modal"].hide();
    },

    showModal() {
      this.$refs["variable-modal"].show();
    }

  }
}
</script>

<style>
#modal-add-variable .form-group {
  width: 45%;
}

</style>
